import React from 'react';
import { IconExclamation } from '@/assets/icons';
import { Button } from '@/components';

interface Props {
  goAddCard: () => void;
  titleError: string;
  messageError: string[];
}

export const ModalErrorMessage: React.FC<Props> = ({ goAddCard, titleError, messageError }) => (
  <section
    aria-labelledby="error-card-title"
    role="alert"
    className="w-full mx-auto text-center px-4 py-6"
    data-testid="modal-error-message"
  >
    <div className="flex flex-col items-center mx-auto max-w-sm">
      <span aria-hidden="true" className="mb-4">
        <IconExclamation height="56" className="mx-auto text-alert-error sm:h-20" />
      </span>

      <h2
        id="error-card-title"
        className="font-dmsans font-bold text-red-600 text-lg sm:text-xl mb-4"
      >
        {titleError}
      </h2>

      <ul className="font-dmsans text-base text-neutro-w-600 mb-6 max-w-[35ch] leading-relaxed space-y-2 list-disc list-inside text-left">
        {messageError.map((msg, index) => (
          <li key={index}>{msg}</li>
        ))}
      </ul>

      <Button
        type="button"
        title="Adicionar outro cartão"
        buttonStyle="primary"
        size="lg"
        className="w-full"
        onClick={goAddCard}
        aria-label="Adicionar outro cartão de crédito"
      />
    </div>
  </section>
);
